"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vp_footer_1 = require("@components/vp-footer");
var config = {
    columns: [
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/qui-sommes-nous'
                    },
                    text: 'Qui sommes-nous ?',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/marques'
                    },
                    text: 'Nos marques partenaires',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/conditions'
                    },
                    text: 'Conditions générales',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/recrutement'
                    },
                    text: 'Offres d\'emploi',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/mentions-legales'
                    },
                    text: 'Mentions légales',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/conditions#2'
                    },
                    text: 'Politique de confidentialité',
                    type: 'link'
                }
            ],
            title: 'À propos de Veepee'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/faq'
                    },
                    text: 'FAQ',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/contact'
                    },
                    text: 'Contactez-nous',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/faq#bons_d_achat_cartes_cadeaux-4'
                    },
                    text: 'Conditions codes avantages',
                    type: 'link'
                },
                {
                    linkProps: {
                        href: '//www.veepee.ch/fr/contact-pro'
                    },
                    text: 'Devenir partenaire',
                    type: 'link'
                }
            ],
            title: 'Aide & Contact'
        },
        {
            items: [
                {
                    icon: vp_footer_1.Icons.Facebook,
                    linkProps: {
                        href: '//www.facebook.com/VeepeeCH/',
                        target: '_blank'
                    },
                    text: '@eboutic',
                    type: 'link'
                },
                {
                    icon: vp_footer_1.Icons.Instagram,
                    linkProps: {
                        href: '//www.instagram.com/veepee_ch/',
                        target: '_blank'
                    },
                    text: '@veepee_ch',
                    type: 'link'
                }
            ],
            mobile: { hideTitle: true },
            title: 'Suivez-nous'
        },
        {
            items: [{
                    text: '',
                    type: 'countryDropdown'
                }],
            title: 'Accès aux autres sites'
        }
    ],
    country: 'CH',
    flag: 'CH-FR',
    lang: 'fr',
    logoSubtitle: ''
};
exports.default = config;
